import { render, staticRenderFns } from "./AppEvents.vue?vue&type=template&id=1caa0c35&scoped=true"
import script from "./AppEvents.vue?vue&type=script&lang=js"
export * from "./AppEvents.vue?vue&type=script&lang=js"
import style0 from "./AppEvents.vue?vue&type=style&index=0&id=1caa0c35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa0c35",
  null
  
)

export default component.exports